module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product afms",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("System monitorowania fauny dla Portów\n          Lotniczych\n        ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Airport Fauna Monitoring System")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/airport/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               Zaczynając od roku 2020, przez trzy lata będziemy tworzyć zintegrowany system detekcji ptaków dedykowany dla portów lotniczych. Dzięki naszym wcześniejszym działaniom, kontaktom w branży i poznaniem oczekiwań przedstawicieli lotnisk z całego świata, wiemy dokładnie jak rozwiązanie ma działać. Będzie to system, który z przestrzeni portów lotniczych będzie zbierał informacje o przelatujących ptakach i przekazywał je do mobilnych służb lotniskowych oraz do wieży kontroli lotów. Ponadto, będzie monitorował pas drogi startowej pod kątem obecności zwierząt, które mogą zagrozić operacjom lotniczym. Dzięki naszemu systemowi pracownicy portu będą mogli zredukować ryzyko kolizji samolotów ze zwierzętami. Partnerem strategicznym w tym projekcie jest Port Lotniczy w Gdańsku.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Tytuł projektu:"), _c('br'), _vm._v("\nPrzeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.\n               ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Cel projektu:"), _c('br'), _vm._v("\nCelem projektu jest przeprowadzenie prac B+R pozwalających na opracowanie prototypu nowego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS - system monitoringu okolic portu lotniczego do detekcji awifauny ssaków lądowych).\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                3 493 437,50PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                2 632 075.00PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               In the years 2020-23, we will develop an integrated bird detection system dedicated to airports. Thanks to our previous actions, contacts and learning about the expectations of representatives of airport from around the world, we know exactly how the solution shall work. It will be a system that will collect information about flocking birds and transmit data to airport services and to the air traffic control tower. In addition, it will monitor the runway for the presence of animals that may endanger air operations. Thanks to our system, airport personnel will be able to reduce the risk of aircraft collisions with animals. The strategic partner in this project is the Gdańsk Airport.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Project title:"), _c('br'), _vm._v("\nCarrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               The aim of the project is to carry out R&D works enabling the development of a prototype of the new AIRPORT FAUNA MONITORING SYSTEM (AFMS - monitoring system around the airport for the detection of land mammal avifauna).\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                3 493 437,50PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                2 632 075.00PLN\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ca1ad86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AFMS.vue
// module id = 275
// module chunks = 0